import React, { useEffect, useState } from "react";
import { Grid, withStyles } from "@material-ui/core";
import ForageOptions from "./ForageOptions";
import PastureOptions from "./PastureOptions";
import { ManejoTab } from "../../components/Tabs/ManejoTab";
import { ManejoTabs } from "../../components/Tabs/ManejoTabs";
import { connect } from "react-redux";
import Auth from "features/authentication/Auth";
import { useTranslations } from "adapters/i18n";
import toggleUtils from "shared/toggleUtils";

function Registrations({ pastoSelecionado, classes, history, toggles }) {
  const { t } = useTranslations();
  const [selectedTab, setSelectedTab] = useState(0);
  const { permissions } = Auth.getSession();
  const useForageCycleLayout =
    selectedTab === 1 && toggleUtils.isForageCycleManagementActive(toggles);

  useEffect(() => {
    if (pastoSelecionado.IdPasto) {
      history.replace("cadastro_editar_pasto");
    }
  }, [pastoSelecionado.IdPasto]);

  const onTabChange = (event, value) => {
    setSelectedTab(value);
  };

  const TabContainer = ({ children }) => (
    <Grid sm={12} item>
      {children}
    </Grid>
  );

  return (
    <Grid
      container
      className={
        useForageCycleLayout
          ? `${classes.root} ${classes.rootForage}`
          : classes.root
      }
    >
      <Grid
        sm={12}
        item
        className={useForageCycleLayout ? classes.tabsForage : undefined}
      >
        <ManejoTabs onChange={onTabChange} value={selectedTab}>
          <ManejoTab label={t("pasture:pastures-tab")} />
          {permissions.cadastrar_ciclo_forragem && (
            <ManejoTab label={t("pasture:forage-tab")} />
          )}
        </ManejoTabs>
      </Grid>
      <Grid sm={12} item>
        {selectedTab === 0 && (
          <TabContainer>
            <PastureOptions history={history} />
          </TabContainer>
        )}
        {permissions.cadastrar_ciclo_forragem && selectedTab === 1 && (
          <TabContainer>
            <ForageOptions />
          </TabContainer>
        )}
      </Grid>
    </Grid>
  );
}

const styles = () => ({
  root: {
    padding: "32px 40px",
  },
  rootForage: {
    padding: "32px 0",
  },
  tabsForage: {
    boxSizing: "border-box",
    paddingLeft: 40,
    paddingRight: 40,
    "@media (max-width: 600px)": {
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
});

const mapStateToProps = (state) => ({
  pastoSelecionado: state.pasto.PastoSelecionado,
  toggles: state.fazenda.Toggles,
});

export default connect(mapStateToProps)(withStyles(styles)(Registrations));
